import { useQuery } from 'react-query';
import { cacheKeys } from './cacheKeys';
import { handleRequest } from '../../redux/services/APIService';

export const useGetRefillRequestMessages = (
  options = { refillRequestId: '' },
) => {
  return useQuery(
    cacheKeys.getRefillRequestMessages(options),
    async () => {
      if (!options?.refillRequestId) return [];

      const response = await handleRequest(
        'get',
        `prescription/${options.refillRequestId}/messages`,
        true,
        null,
        options.filter,
      );

      return response.data;
    },
    {
      onError: (error) => {
        console.error(
          `${error.response?.data?.data?.resultMessage || error.message}`,
        );
      },
      ...options,
    },
  );
};
